import { PURGE_AUTH, SET_AUTH, SET_PERMISSIONS } from "../mutations.type";
import JwtService from "@/common/jwt.service.js";

export const state = {
  isLogged: false,
  permissions: [],
};

const mutations = {
  [SET_AUTH](state, user) {
    state.isLogged = true;
    JwtService.saveToken(user.token);
    JwtService.saveUsername(user.username);
    JwtService.saveRole(user.roles);
    JwtService.saveName(user.name);
  },
  [PURGE_AUTH]() {
    state.isLogged = false;
    JwtService.destroyToken();
    JwtService.destroyUsername();
    JwtService.destroyName();
    JwtService.destroyRole();
  },
  [SET_PERMISSIONS](state, permissions) {
    state.permissions = permissions;
  },
};

const getters = {
  permissions(state) {
    return state.permissions;
  },
};

export default {
  state,
  mutations,
  getters,
};
